import React, {useState, forwardRef, useImperativeHandle} from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import './searchfilter.css';

type SearchFilterProps = {
  items: Array<string>;
  handleSearchFilter: (term: string) => void;
}
export const SearchFilter = forwardRef((props: SearchFilterProps, ref) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectItem, setSelectItem] = useState('');

  const handleSelect = (e: React.MouseEvent<HTMLButtonElement>) => {
    setSelectItem(e.currentTarget?.value);
    const term = e.currentTarget?.value;
    if (term === 'all') {
      props.handleSearchFilter('');
    } else {
      props.handleSearchFilter(term);
    }
  };

  useImperativeHandle(ref, () => ({
    clearSelect() {
      setSelectItem('all');
    },
  }));

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <div className="SearchFilter">
      {props.items.length > 0 &&
      <Dropdown isOpen={dropdownOpen} toggle={toggle} className="dropdown-wrap">
        <DropdownToggle caret cssModule={{'btn-secondary': 'SearchFilter__search-filter'}}>{selectItem && selectItem !== 'all' ? selectItem : 'Filter by'}</DropdownToggle>
        <DropdownMenu>
          {props.items.map((item) => (
            <DropdownItem key={item} value={item} onClick={handleSelect} className='SearchFilter__item-option'>{item}</DropdownItem>
          ))}
          <DropdownItem value='all' onClick={handleSelect} className='SearchFilter__item-option'>Unset (all)</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      }
    </div>
  );
});
SearchFilter.displayName = 'SearchFilter';
